import relays from './relays';
import n2k from './n2k';
import device from './device';
import progress from './progress';
const Handlers = [
    relays,
    n2k,
    device,
    progress,
];
export default Handlers;
